var shopCommon = {
	adyen: {
		clientKey: "live_7YMWKCE4B5GQFOJ7ROO35L7EDMHX5RNA"
	}
};
var zooplus = {
	paypal: {
		clientId: "ARnCYfY6j3qid5w7dQHUMtoRebesjooa-ZDvw-sgChzdIap0eGlxO5rwLQy-TwKB9FNtMvEaXjKOGatC"
	},
	bancontact: {
		adyenScriptSrc: "https://checkoutshopper-live.adyen.com/checkoutshopper/utility/v1/cse/js/2614357026975069.shtml",
		adyenScriptIntegrity: "sha-384-HpbwtzJGdFgA7KgxbZlwxTAvXqWAc7JeT4XMz6V2sVbHK7FVBUKoo4fgKcj0W9q7"
	},
	optimizely: {
		clientId: "Bfs6fZwnaYustGYvQv3Ws"
	}
};
var bitiba = {
	paypal: {
		clientId: "AfWrLXLdbApBAVcEvM7xmQwr2QhHMk6jbvAx4jDMnS4QGmkdxQ5uKDfwOV0jHyPC-0pRSisTRpB7sEby"
	},
	bancontact: {
		adyenScriptSrc: "https://checkoutshopper-live.adyen.com/checkoutshopper/utility/v1/cse/js/2614357026975069.shtml",
		adyenScriptIntegrity: "sha-384-HpbwtzJGdFgA7KgxbZlwxTAvXqWAc7JeT4XMz6V2sVbHK7FVBUKoo4fgKcj0W9q7"
	},
	optimizely: {
		clientId: "Bfs6fZwnaYustGYvQv3Ws"
	}
};
var prodConfig = {
	shopCommon: shopCommon,
	zooplus: zooplus,
	bitiba: bitiba
};

export { bitiba, prodConfig as default, shopCommon, zooplus };
//# sourceMappingURL=prod.json.js.map
